/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'resources/less/themes/base/pages/standalone/design_gallery.less';

import 'APP_THEME/_common/legacy/core';
import 'jquery-ui/jquery-ui';
import 'assets/js/start/regionWidgetSwitch';
import DesignGalleryView from 'assets/js/modules/designGallery/designGalleryView';
import DesignGalleryModel from 'assets/js/modules/designGallery/designGalleryModel';

import 'lazysizes';

$(function() {
    $('.template-image-link img[data-src]').show();
    $('.first-level-categories').each(function() {
        var $this = $(this);
        var $linksBlock = $this.find('.show-all-links');

        // Additional categories are hidden by default. If chosen category is in additional category,
        // all additional categories should be shown.
        var isOpen = $this.find('.additional-category.open').length > 0;
        var isChosen = $this.find('.additional-category.chosen').length > 0;
        if (isOpen || isChosen) {
            $linksBlock.siblings('.additional-category').show();
            var $link = $linksBlock.find('.show-all');
            $link.hide();
            $link.siblings().show();
        }

        // Link 'Show All' appears if category has more children than MAX_SHOWN_CATEGORIES constant.
        // But not all of them can be displayed on page. Needs additional check after category tree has been loaded.
        var $galleryCategory = $this.find('.gallery-category');
        if ($galleryCategory.length <= $galleryCategory.data('max-shown-categories')) {
            $linksBlock.remove();
        }
    });

    var $body = $('body');
    $body.on('click', '.toggle-sub-categories, .root-category .gallery-category-name', function(e) {
        var $this = $(this);
        $this
            .closest('.gallery-category')
            .find('.toggle-sub-categories')
            .first()
            .toggleClass('open closed');
        $this.siblings('.gallery-sub-categories').slideToggle();
    });

    $body.on('click', '.show-all-links a', function(e) {
        e.preventDefault();
        var $this = $(this);
        $this.hide();
        $this.siblings().show();
    });

    $body.on('click', '.show-all', function() {
        $(this)
            .parent()
            .siblings('.additional-category')
            .slideDown();
    });

    $body.on('click', '.hide-all', function() {
        $(this)
            .parent()
            .siblings('.additional-category')
            .slideUp();
    });

    var $galleryPageContainer = $('#gallery-page-container');
    new DesignGalleryView({
        el: $('.body-content'),
        model: new DesignGalleryModel({
            galleryUrlSlug: $galleryPageContainer.data('gallery-url-slug'),
            productGroupName: $galleryPageContainer.data('product-group-name'),
            productSlug: $galleryPageContainer.data('product-slug'),
            sideNames: $galleryPageContainer.data('side-names'),
            color: $galleryPageContainer.data('color'),
            query: $galleryPageContainer.data('query'),
            page: $galleryPageContainer.data('page'),
            totalPages: $galleryPageContainer.data('total-pages'),
            templatesPerPage: $galleryPageContainer.data('templates-per-page'),
            orientation: $galleryPageContainer.data('orientation'),
            categories: $galleryPageContainer.data('categories')
        })
    });

    $('#custom-design-services').on('click', function() {
        if (window.SnapEngage !== undefined) {
            return window.SnapEngage.startLink();
        } else {
            console.log('SnapEngage not loaded.');
        }
    });
});
